(function () {
  if (window.__seoBreadcrumbFollowInitialized) return;
  window.__seoBreadcrumbFollowInitialized = true;

  var BREAKPOINT = 990;
  var DESKTOP_TARGET = "/collections/all";
  var LINK_SELECTOR = ".seo-bc__link";
  var MENU_SELECTOR = ".header__icon--menu.header__icon--summary";

  function normalizePath(href) {
    try {
      var url = new URL(href, window.location.origin);
      return (url.pathname || "/").replace(/\/+$/, "") || "/";
    } catch (error) {
      return "";
    }
  }

  function isCollectionsLink(href) {
    var path = normalizePath(href);
    return path === "/collection" || path === "/collections";
  }

  function syncLinksForViewport() {
    var isDesktop = window.innerWidth >= BREAKPOINT;
    var links = document.querySelectorAll(LINK_SELECTOR);

    links.forEach(function (link) {
      var currentHref = link.getAttribute("href") || "";

      if (!link.hasAttribute("data-seo-bc-original-href")) {
        link.setAttribute("data-seo-bc-original-href", currentHref);
      }

      var originalHref =
        link.getAttribute("data-seo-bc-original-href") || currentHref;
      if (!isCollectionsLink(originalHref)) return;

      if (isDesktop) {
        if (link.getAttribute("href") !== DESKTOP_TARGET) {
          link.setAttribute("href", DESKTOP_TARGET);
        }
        return;
      }

      if (link.getAttribute("href") !== originalHref) {
        link.setAttribute("href", originalHref);
      }
    });
  }

  function onBreadcrumbClick(event) {
    var link = event.target.closest(LINK_SELECTOR);
    if (!link) return;

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.target === "_blank"
    ) {
      return;
    }

    var originalHref =
      link.getAttribute("data-seo-bc-original-href") ||
      link.getAttribute("href") ||
      "";
    if (!isCollectionsLink(originalHref)) return;

    if (window.innerWidth >= BREAKPOINT) {
      event.preventDefault();
      window.location.assign(DESKTOP_TARGET);
      return;
    }

    event.preventDefault();
    var menuButton = document.querySelector(MENU_SELECTOR);

    if (menuButton) {
      menuButton.click();
      return;
    }

    window.location.assign(DESKTOP_TARGET);
  }

  function init() {
    syncLinksForViewport();

    document.addEventListener("click", onBreadcrumbClick, true);
    window.addEventListener("resize", syncLinksForViewport);
    document.addEventListener("shopify:section:load", syncLinksForViewport);

    var observer = new MutationObserver(function () {
      syncLinksForViewport();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["href", "class"],
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
